export default "__VITE_PUBLIC_ASSET__8ee7f891__"